import { ParamsWithPagination } from '@/types/api';

import { ChannelRecordingFilters } from '../types';

export const channelRecordingsQueryKeys = {
  all: ['channelRecordings'] as const,
  lists: () => [...channelRecordingsQueryKeys.all, 'list'] as const,
  list: (params?: ParamsWithPagination<ChannelRecordingFilters>) =>
    [...channelRecordingsQueryKeys.lists(), params] as const,
};
